import React, { useEffect, useRef, useState } from "react";
import { Empty, Tabs, Steps } from "antd";
import Box from "@mui/material/Box";
import { Button, Checkbox, Form, Input, Select } from "antd";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import dateFormat from "dateformat";

import {
  FileWordOutlined,
  FileDoneOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import MainHeader from "../MainHeader/MainHeader";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import Tabss from "../Intruction/Tabs";
import { CKEditor } from "ckeditor4-react";
import { toast } from "react-toastify";
import { Alert } from "antd";
import TextEditor from "../TextEditor";
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Step } = Steps;
const { TabPane } = Tabs;
const { TextArea } = Input;

function DuplicateInstructioneditable({ t }) {
  const editorRef = useRef(null);

  const lan = useSelector((state) => state.langReducer);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [data, setDatas] = useState();
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const [editable, setEditable] = useState(false);
  const [error, setError] = useState();
  const [cerificate_file, setCerificateFile] = useState(null);
  const [duplicate_app_file, setDuplicateAppFile] = useState(null);
  const [textValue, setTextValue] = useState('');
  const [general, setgeneral] = useState({ uz: "", ru: "", en: "" });

  const [fileList, setFileList] = useState([]);
  const [fileAppList, setAppFileList] = useState([]);

  const [usage, setusage] = useState({ uz: "", ru: "", en: "" });
  const [prevention, setprevention] = useState({ uz: "", ru: "", en: "" });

  useEffect(() => {
    axios
      .get(url.url + `/duplicate-application/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        setDatas(res.data.data);
        setCerificateFile(res.data.data.certificate_file);
        setDuplicateAppFile(res.data.data.duplicate_app_file);
        setgeneral(res.data.data.drug.instruction?.general);
        setusage(res.data.data.drug.instruction?.usage);
        setprevention(res.data.data.drug.instruction?.prevention);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        // if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
      });
  }, []);
  const handleSave = () => {
    if (!cerificate_file || !duplicate_app_file) {
      toast.error("Iltimos, barcha maydonlarni to‘ldiring");
      setError(['Iltimos, barcha maydonlarni to‘ldiring']);
      return;
    }
    const formData = new FormData();
    formData.append('cerificate_file', cerificate_file);
    formData.append('duplicate_app_file', duplicate_app_file);
    axios
      .post(url.url + `/duplicate-application/${searchParams.get("id")}/instruction`, formData, {
        headers: headers(),
      })
      .then((res) => {
        if (res.status == 200) {
          setError();
          navigate({
            pathname: "/account/duplicate-applications",
          });
          toast.success(t("Success!"));
        }
      })
      .catch((err) => {
        setError(err.response.data.errors);
      });
  };
  const [keys, setKeys] = useState("1");

  const changeTab = (activeKey) => {
    setKeys(activeKey);
  };
  useEffect(() => {
    axios
      .get(url.url + `/duplicate-application/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        if (res.data.data.editable == 1) setEditable(true);
      });
  }, [lan]);

  useEffect(() => {
    if (cerificate_file && typeof cerificate_file === 'string') {
      setFileList([
        {
          uid: '-1',
          name: cerificate_file.split('/').pop() || 'eski_sertifikat.pdf',
          status: 'done',
          url: 'https://nefrit-api.vetgov.uz/' + cerificate_file,
        },
      ]);
    }
  }, [cerificate_file]);

  useEffect(() => {
    if (duplicate_app_file && typeof duplicate_app_file === 'string') {
      setAppFileList([
        {
          uid: 'duplicate-2',
          name: duplicate_app_file.split('/').pop() || 'eski_duplikat_app.pdf',
          status: 'done',
          url: 'https://nefrit-api.vetgov.uz/' + duplicate_app_file,
        },
      ]);
    }
  }, [duplicate_app_file]);

  const handleBeforeUpload = (file) => {
    setCerificateFile(file);

    setFileList([
      {
        uid: String(Date.now()),
        name: file.name,
        status: 'done',
        url: URL.createObjectURL(file),
      },
    ]);

    return false;
  };
  const handleDuplicateBeforeUpload = (file) => {
    setDuplicateAppFile(file);

    setAppFileList([
      {
        uid: String(Date.now()),
        name: file.name,
        status: 'done',
        url: URL.createObjectURL(file),
      },
    ]);

    return false;
  };


  return (
    <div>
      <MainHeader title={t("Edit application")} />

      <div className="add-application">
        <Box sx={{ width: "100%" }}>
          <Steps>
            <Step
              status="finish"
              title={t("Application")}
              icon={<SolutionOutlined />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (searchParams.get("con_id"))
                  navigate({
                    pathname: "/account/duplicate-applications/edit",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                      con_id: searchParams.get("con_id"),
                    })}`,
                  });
                else
                  navigate({
                    pathname: "/account/duplicate-applications/edit",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                    })}`,
                  });
              }}
            />
            <Step
              status="process"
              title={t("Additional information")}
              icon={<FileDoneOutlined />}
            />
          </Steps>
        </Box>
      </div>
      <div className="form-body-wrapp">
        <div className="frm-con" style={{ width: "100%" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5 className="app-title">{t("Additional_information")}</h5>
          </div>
          <div >
            <FormControl fullWidth>
              <Input.TextArea
                placeholder="Qo‘shimcha maʼlumot yozing"
                value={textValue}
                onChange={(e) => setTextValue(e.target.value)}
                rows={4}
                style={{ marginBottom: 16 }}
              />

              <div>
                <h6>{t("Reason for duplication")}</h6>
                <Upload fileList={fileAppList} beforeUpload={handleDuplicateBeforeUpload} onRemove={() => {
                  setAppFileList([]);
                  setDuplicateAppFile(null);
                }} maxCount={1} style={{ marginTop: 8 }}>
                  <Button icon={<UploadOutlined />}>Dublikat olish sababi xat ilova</Button>
                </Upload>
              </div>

              <div style={{ marginTop: 16 }}>
                <h6>{t("Old certificate")}</h6>
                <Upload fileList={fileList} beforeUpload={handleBeforeUpload} onRemove={() => {
                  setFileList([]);
                  setCerificateFile(null);
                }} maxCount={1} style={{ marginTop: 8 }}>
                  <Button icon={<UploadOutlined />}>Eski sertifikat</Button>
                </Upload>
              </div>
            </FormControl>
          </div>
        </div>
      </div>

      {/* {editable ? (

      ) : (
      )} */}
      <div className="btn-gr d-flex ">
        {editable ? (
          <div className="d-flex flex-wrap">
            <div className="mr-1">
              <Button
                className="doc-btnn"
                type="primary"
                size={20}
                onClick={() => navigate("/account/duplicate-applications")}
              >
                {t("Cancel")}
              </Button>
            </div>
            <div className="btn-pr-form mr-0">
              <Button
                className="doc-btnn"
                type="primary"
                size={20}
                onClick={handleSave}
              >
                {t("Save")}
              </Button>
            </div>
          </div>
        ) : (
          <div className="btnn-holderr">
            <Button type="primary" size={20} onClick={() => navigate(-1)}>
              {t("Back")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
export default withTranslation()(DuplicateInstructioneditable);
